exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 767px) {\n.site-header {\n    height: 50px;\n}\n.site-header__container:before {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    background-color: #000000;\n    z-index: 1001;\n    content: \"\";\n}\n}\n@media print {\n.site-header {\n    display: none !important;\n}\n}\n", ""]);

// exports
